import { ApiSlideSettings, SlideSettings } from 'apps/arsultima/src/app/models/settings.model';
import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';

import { IMAGES_FILENAME_PREFIX } from '../../../../models/image.model';
import { ImageService } from './../../../../services/image.service';
import { Pages } from 'apps/arsultima/src/app/models/pages.enum';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'arsultima-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit, OnChanges {
  @Input()
  page: Pages;

  @Input()
  slides: ApiSlideSettings[];

  @Input()
  isEditable = false;

  activeSlide = 0;
  config: SwiperOptions;

  constructor(private readonly imageService: ImageService) {}

  ngOnInit(): void {
    this.config = {
      pagination: { el: '.swiper-pagination', clickable: true },
      direction: 'horizontal',
      speed: 1000,
      autoplay: true,
    };
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    const { slide } = changes;
    if (slide && slide.currentValue) {
      this.slides = slide.currentValue;
    }
  }

  getImageUrl(slideData: ApiSlideSettings): string {
    const id = slideData.ID;
    const homeSettings = new SlideSettings(slideData);
    if (homeSettings.fileName) {
      return this.imageService.getImageUrl(id, { prefix: IMAGES_FILENAME_PREFIX.slides });
    }
  }
}
